import React from 'react'
import { SearchableEntity } from './SelectEntitiesForm.types'
import {
  SelectEntitiesModalDataContext,
  SelectEntitiesModalDataContextType
} from './context'

type FetchEntitiesFromBackendWithCustomQueryProps = {
  loadEntities: CustomEntitiesLoader
}

export type CustomEntitiesLoader = () => Promise<SearchableEntity[]>

export const FetchEntitiesFromBackendWithCustomQuery: React.FC<FetchEntitiesFromBackendWithCustomQueryProps> =
  ({ children, loadEntities }) => {
    const [entities, setEntities] = React.useState<SearchableEntity[]>([])

    React.useEffect(() => {
      loadEntities().then(setEntities)
    }, [])

    const contextValue = React.useMemo(
      (): SelectEntitiesModalDataContextType => ({
        entities
      }),
      [entities]
    )

    return (
      <SelectEntitiesModalDataContext.Provider value={contextValue}>
        {children}
      </SelectEntitiesModalDataContext.Provider>
    )
  }
